// src/components/Experiment/ContextMenu.js
import React, { useEffect, useRef } from 'react';
import './ContextMenu.css';

const ContextMenu = ({ x, y, onCopy, onCut, onPaste, onDelete, canPaste, onHide }) => {
  // Add this at the top of the ContextMenu component
    console.log("ContextMenu rendered with props:", {
      x, y,
      onCopy: typeof onCopy,
      onCut: typeof onCut,
      onPaste: typeof onPaste,
      onDelete: typeof onDelete,
      canPaste
    });
  
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        console.log("Click outside context menu");
        onHide();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onHide();
      }
    };

    // Add a small delay before attaching the event listener
    // to prevent immediate triggering when the menu opens
    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onHide]);

  const handleMenuClick = (action) => {
    console.log("Context menu action clicked");
    // Call the action first
    action();
    // Then hide the menu after a small delay to ensure the action completes
    setTimeout(() => {
      onHide();
    }, 100);
  };

  // Adjust position to prevent menu from going off-screen
  const adjustPosition = (pos, max) => {
    return Math.min(pos, max - 200);
  };

  const adjustedX = adjustPosition(x, window.innerWidth);
  const adjustedY = adjustPosition(y, window.innerHeight);

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{
        position: 'fixed',
        left: adjustedX,
        top: adjustedY,
        zIndex: 1000
      }}
    >
      <div className="context-menu-item" onClick={() => handleMenuClick(onCopy)}>
        <i className="bi bi-clipboard me-2"></i>
        Copy
        <span className="shortcut">Ctrl+C</span>
      </div>

      <div className="context-menu-item" onClick={() => handleMenuClick(onCut)}>
        <i className="bi bi-scissors me-2"></i>
        Cut
        <span className="shortcut">Ctrl+X</span>
      </div>

      <div
        className={`context-menu-item ${!canPaste ? 'disabled' : ''}`}
        onClick={canPaste ? () => handleMenuClick(onPaste) : undefined}
      >
        <i className="bi bi-clipboard-plus me-2"></i>
        Paste
        <span className="shortcut">Ctrl+V</span>
      </div>

      <div className="context-menu-separator"></div>

      <div className="context-menu-item" onClick={() => handleMenuClick(onDelete)}>
        <i className="bi bi-trash me-2"></i>
        Delete
        <span className="shortcut">Del</span>
      </div>
    </div>
  );
};

export default ContextMenu;;